import { StyledSuggestedSimpleChipItem } from "./styles";

export type SuggestedChipItemProps = {
    id: string;
    text: string;
    onApply(): void;
    /** Omit to render the chip without a dismiss button. */
    onDismiss?(): void;
};

/** `id` identifies the item for the list rendering it, so the chip itself does not take it. */
export const SuggestedChipItem = ({ text, onApply, onDismiss }: Omit<SuggestedChipItemProps, "id">) => {
    return (
        <StyledSuggestedSimpleChipItem
            text={text}
            customIcon="plus-circle-filled"
            hideActionButton={!onDismiss}
            isCompact
            onClick={onApply}
            onCloseItem={onDismiss}
            maxAmountOfCharacters={30}
        />
    );
};
